// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1-eXN","calendarButtons":"ClockData_calendarButtons__23i75"};